import { DestroyRef, inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanMatch,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { UserRightsXsState } from '../../states/user-rights/user-rights-xs.state';
import { UserRoleIdUtil } from '../../utils/UserRoleIdUtil';
import { RedirectUtil } from '../../utils/RedirectUtil';
import { filter, map, take } from 'rxjs/operators';
import { STATE_INITIALIZED } from '../../shared.app.rights.context';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable()
export class ServiceProviderModuleAdminRoleGuard implements CanActivate, CanMatch {

  private router: Router = inject(Router);
  private store: Store = inject(Store);
  readonly #destroyRef = inject(DestroyRef);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.can();
  }

  canMatch(route: Route, segments: UrlSegment[]): Observable<boolean> {
    return this.can();
  }

  private can(): Observable<boolean> {
    return STATE_INITIALIZED.pipe(
      takeUntilDestroyed(this.#destroyRef),
      filter((initialized) => initialized),
      take(1),
      map(() => {
        const userRoleId = this.store.selectSnapshot(UserRightsXsState.activeUserRightsRoleId);
        const isServiceProviderModuleAdmin: boolean
          = userRoleId === UserRoleIdUtil.SERVICE_PROVIDER_MODULE_ADMIN_ROLE_ID;
        if (!isServiceProviderModuleAdmin) {
          this.router.navigate([RedirectUtil.getHomeRedirectUrl()]);
        }
        return isServiceProviderModuleAdmin;
      })
    );
  }
}
